/* EF Lab: one actual configurator in one permanent product-column location.
   Prefer server-rendered placement. Legacy markup may move once with native
   state-preserving moveBefore; Next, Back, Review and resume never relocate it.
   No engine/selection/price writes, cloned controls or synthetic Next.
   Sticky Build delegates once to the native validator; feedback never decides
   whether a step is valid or writes selections, dimensions or prices. */
(function () {
  'use strict';
  function init() {
    var hosts = document.querySelectorAll('[data-ef-lab-door-entry-host]');
    var roots = document.querySelectorAll('#efCfg');
    if (hosts.length !== 1 || roots.length !== 1) return;
    var host = hosts[0], cfg = roots[0], page = host.closest('.efx-pdp');
    var studio = cfg.closest('.efx-pdp__studio'), origin = cfg.parentElement;
    if (!page || !page.contains(cfg) || cfg.contains(host) || !origin) return;
    // Server-rendered forms work without the optional DOM move API. A legacy
    // form stays usable in its original location if an atomic move is unavailable.
    if (cfg.parentElement !== host && (!studio || typeof host.moveBefore !== 'function')) return;
    if (host.dataset.efLabEntryBound) return;
    var type = cfg.dataset.cfgType;
    if (['cfg-standard', 'cfg-simple', 'cfg-custom', 'cfg-custom-full', 'cfg-custom-premium', 'cfg-screen'].indexOf(type) < 0) return;
    host.dataset.efLabEntryBound = 'true';
    var single = type === 'cfg-standard' || type === 'cfg-simple';
    var placed = false, lastStep = null, failed = false, initialResolved = false;
    var pendingHuman = false, intentTimer = null, focusFrame = null;
    var note = null, cueInstruction = null;
    var attemptedStep = null, feedback = [], feedbackTimer = null;

    function visibleStep() {
      var steps = cfg.querySelectorAll('.ef-cfg-step.is-visible');
      return steps.length === 1 ? steps[0] : null;
    }
    function currentPosition() {
      var progress = cfg.querySelector('#efCfgProgress');
      return progress ? Number(progress.getAttribute('aria-valuenow')) : 0;
    }
    function makePresentation() {
      if (!note) {
        note = document.createElement('header');
        note.className = 'ef-lab-door-entry__note';
        var cueHeading = document.createElement('h2');
        cueHeading.className = 'ef-lab-door-entry__heading';
        cueHeading.textContent = type === 'cfg-screen' ? 'Configure your screen' : 'Configure your door';
        cueInstruction = document.createElement('p');
        cueInstruction.className = 'ef-lab-door-entry__instruction';
        note.appendChild(cueHeading);
        note.appendChild(cueInstruction);
        host.insertBefore(note, host.firstChild);
        if (!single) host.dataset.efLabEntryCue = type === 'cfg-screen' ? 'screen' : 'door';
      }
      updateCue();
    }
    function updateCue() {
      if (!cueInstruction) return;
      // Read native progress, including screens that skip the fireplace step.
      cueInstruction.textContent = currentPosition() === 1
        ? (type === 'cfg-screen' ? 'Start with your screen size.' : 'Start by choosing your fireplace type.')
        : 'Choose your options below. Your choices are kept as you continue.';
    }
    function showPlacement() {
      makePresentation();
      note.hidden = single;
      page.dataset.efLabDoorEntry = 'hero';
      if (!single && page.hasAttribute('data-ef-lab-continuous')) prepareBuyerHierarchy();
      if (studio && !studio.contains(cfg)) studio.setAttribute('data-ef-lab-entry-empty', '');
    }
    function prepareBuyerHierarchy() {
      // Show the real first decision before the optional photo route. Move the
      // existing group once: IDs, listeners, values and native validation stay.
      var first = cfg.querySelector('[data-group="fireplace_type"]');
      var ai = cfg.querySelector('#efCfgAiBtn');
      if (first && ai && first.parentElement === ai.parentElement) {
        first.parentElement.insertBefore(first, ai);
        var title = ai.querySelector('.ef-cfg-ai-cta__title');
        if (title) title.textContent = 'Not sure which type? Identify it from a photo';
      }
      // These are presentation headings, not product claims or option labels.
      var help = cfg.querySelector('#efCfgHelpPanel .ef-cfg-help__title-two');
      if (help) help.textContent = 'Need help measuring?';
      var review = cfg.querySelector('#efCfgStepReview');
      // Optional cross-sells must not bury the order. Their original controls
      // remain in the same native module; selected extras stay visible in the
      // disclosure label and are never reset when the disclosure is closed.
      var extras = review && review.querySelector('[data-efx-uac]');
      if (extras && !extras.closest('.ef-lab-order-extras')) {
        var disclosure = document.createElement('details');
        disclosure.className = 'ef-lab-order-extras';
        var summary = document.createElement('summary');
        var extrasTitle = document.createElement('span');
        var extrasHint = document.createElement('span');
        extrasHint.className = 'ef-lab-order-extras__hint';
        extrasTitle.className = 'ef-lab-order-extras__title';
        extrasHint.textContent = 'Gas logs, tool sets, log holders & grates';
        var extrasBadge = document.createElement('span');
        extrasBadge.className = 'ef-lab-order-extras__badge';
        extrasBadge.textContent = 'SAVE 10%';
        var extrasTerms = document.createElement('span');
        extrasTerms.className = 'ef-lab-order-extras__terms';
        extrasTerms.textContent = 'Optional · 10% off at checkout with your ' + (type === 'cfg-screen' ? 'screen.' : 'door.');
        if (type === 'cfg-screen') extras.querySelectorAll('option[value="Match my door"]').forEach(function (option) { option.textContent = 'Match my screen’s finish'; });
        summary.append(extrasTitle, extrasBadge, extrasHint, extrasTerms);
        disclosure.appendChild(summary);
        extras.parentElement.insertBefore(disclosure, extras);
        disclosure.appendChild(extras);
        function describeExtras() {
          if (type === 'cfg-screen') {
            var note = extras.querySelector('[data-efx-uac-note]');
            if (note) { var walker=document.createTreeWalker(note,NodeFilter.SHOW_TEXT), node; while(node=walker.nextNode()) { var wording=node.nodeValue.replace(/\bdoor\b/g,'screen'); if(wording!==node.nodeValue) node.nodeValue=wording; } }
          }
          var count = extras.querySelectorAll('input[data-efx-acc-tick]:checked').length;
          extrasTitle.textContent = count ? 'Accessories · ' + count + ' selected' : 'Add accessories';
          return count;
        }
        if (describeExtras()) disclosure.open = true;
        extras.addEventListener('change', describeExtras);
        window.addEventListener('ef-cfg:state-changed', describeExtras);
        var nativeNote = extras.querySelector('[data-efx-uac-note]');
        if (nativeNote) new MutationObserver(describeExtras).observe(nativeNote, { childList:true, subtree:true, attributes:true, attributeFilter:['hidden'] });
      }
      page.dataset.efLabBuyerHierarchy = 'true';
    }
    function placeOnce() {
      if (placed) return true;
      if (cfg.parentElement !== host) {
        try { host.moveBefore(cfg, null); }
        catch (_) {
          failed = true;
          return false; // Preserve the complete original form and fallback anchor.
        }
      }
      placed = true;
      showPlacement();
      return true;
    }
    function focusCurrent() {
      if (focusFrame !== null) cancelAnimationFrame(focusFrame);
      focusFrame = requestAnimationFrame(function () {
        focusFrame = null;
        if (!cfg.isConnected) return;
        var step = visibleStep();
        var heading = step && Array.prototype.find.call(step.querySelectorAll('.ef-cfg-step__title, h2, h3, .ef-cfg-group__label'), function (el) {
          var rect = el.getBoundingClientRect();
          return rect.width > 2 && rect.height > 2;
        });
        if (heading) {
          if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
          heading.focus({ preventScroll: true });
        }
      });
    }
    function isShown(el) {
      return !!el && el.isConnected && el.getClientRects().length > 0 &&
        !el.closest('[hidden], .ef-cfg-group--disabled');
    }
    function choiceLabel(group) {
      var label = group.querySelector('.ef-cfg-group__label');
      if (!label) return (group.dataset.group || 'an option').replace(/_/g, ' ');
      var copy = label.cloneNode(true);
      copy.querySelectorAll('.ef-cfg-group__pick, .ef-cfg-group__opt').forEach(function (el) { el.remove(); });
      return copy.textContent.replace(/^\s*choose\s+/i, '').replace(/\s+/g, ' ').trim().toLowerCase();
    }
    function missingChoices(step) {
      var issues = [];
      var nativeSelections = window._efCfgState && window._efCfgState.selections || {};
      step.querySelectorAll('.ef-cfg-group').forEach(function (group) {
        if (!isShown(group) || group.dataset.group === 'extras') return;
        var grid = group.querySelector('.ef-cfg-group__grid, .ef-cfg-swatch-grid');
        if (!isShown(grid)) return;
        var swatchGroup = grid.classList.contains('ef-cfg-swatch-grid');
        // The native validator requires the main finish, not separate decorative
        // style/hardware finishes. Browsing a tab does not erase a stored finish.
        if (swatchGroup && group.dataset.group !== 'finish') return;
        var controls = Array.prototype.filter.call(grid.querySelectorAll('.ef-cfg-card, .ef-cfg-swatch'), function (el) {
          return isShown(el) && !el.disabled && el.getAttribute('aria-disabled') !== 'true';
        });
        var selected = swatchGroup ? !!nativeSelections.finish : !!grid.querySelector('[aria-checked="true"]');
        if (controls.length && !selected) {
          issues.push({ group: group, grid: grid, controls: controls, label: choiceLabel(group), verb: 'Choose ' });
        }
      });
      // The native finish grid has no .ef-cfg-group wrapper.
      var finish = step.querySelector('#efCfgSwatchGrid');
      if (isShown(finish) && !finish.closest('.ef-cfg-group') && !nativeSelections.finish) {
        var swatches = Array.prototype.filter.call(finish.querySelectorAll('.ef-cfg-swatch'), function (el) { return isShown(el) && !el.disabled; });
        if (swatches.length) issues.push({ group: finish, grid: finish, controls: swatches, label: 'a finish', verb: 'Choose ' });
      }
      // Only native measurement inputs; optional notes/uploads are never flagged.
      var fields = {
        efCfgWidth: 'the opening width', efCfgHeight: 'the opening height',
        efCfgStdWidth: 'an opening width', efCfgStdHeight: 'an opening height',
        efCfgDeluxeOverallW: 'the overall width', efCfgDeluxeOverallH: 'the overall height',
        efCfgDeluxeOpeningW: 'the opening width', efCfgDeluxeOpeningH: 'the opening height',
        efCfgDeluxeTopOffset: 'the top offset', efCfgDeluxeBottomOffset: 'the bottom offset'
      };
      Object.keys(fields).forEach(function (id) {
        var input = step.querySelector('#' + id);
        if (isShown(input) && !input.disabled && !String(input.value || '').trim()) {
          issues.push({ group: input, grid: input, controls: [input], label: fields[id], verb: input.tagName === 'SELECT' ? 'Choose ' : 'Enter ' });
        }
      });
      return issues;
    }
    function removeFeedback(record) {
      record.group.removeAttribute('data-ef-lab-choice-missing');
      record.controls.forEach(function (control) {
        var ids = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (id) { return id && id !== record.message.id; });
        if (ids.length) control.setAttribute('aria-describedby', ids.join(' '));
        else control.removeAttribute('aria-describedby');
        // These native controls have no aria-invalid before the enhancement.
        if (control.getAttribute('data-ef-lab-invalid') === 'true') {
          control.removeAttribute('aria-invalid'); control.removeAttribute('data-ef-lab-invalid');
        }
      });
      record.message.remove();
      var nativeError = document.getElementById('efCfgErr_' + (record.group.dataset.group || (record.grid.id === 'efCfgSwatchGrid' ? 'finish' : '')));
      if (nativeError) nativeError.remove();
      if (/192,\s*83,\s*58|#c0533a/i.test(record.grid.style.outline)) {
        record.grid.style.outline = ''; record.grid.style.outlineOffset = '';
      }
      if (/192,\s*83,\s*58|#c0533a/i.test(record.grid.style.borderColor)) record.grid.style.borderColor = '';
    }
    function clearFeedback() {
      feedback.forEach(removeFeedback); feedback = []; attemptedStep = null;
    }
    function refreshFeedback(focus) {
      if (!attemptedStep || attemptedStep !== visibleStep()) { clearFeedback(); return; }
      var issues = missingChoices(attemptedStep);
      feedback = feedback.filter(function (record) {
        if (issues.some(function (issue) { return issue.group === record.group; })) return true;
        removeFeedback(record); return false;
      });
      issues.forEach(function (issue, index) {
        var record = feedback.find(function (item) { return item.group === issue.group; });
        if (!record) {
          var message = document.createElement('p');
          message.id = 'efLabChoice_' + (issue.group.dataset.group || issue.grid.id || index);
          message.className = 'ef-lab-door-entry__missing';
          message.textContent = issue.verb + issue.label + ' to continue.';
          var insertion = issue.grid.closest('.ef-cfg-input-suffix') || issue.grid;
          insertion.before(message);
          record = issue; record.message = message; feedback.push(record);
        }
        record.group.setAttribute('data-ef-lab-choice-missing', 'true');
        record.message.setAttribute('role', index === 0 ? 'alert' : 'note');
        // A native option grid can be rebuilt after a dependent choice.
        record.controls = issue.controls;
        record.controls.forEach(function (control) {
          var ids = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
          if (ids.indexOf(record.message.id) < 0) { ids.push(record.message.id); control.setAttribute('aria-describedby', ids.join(' ')); }
          if (!control.hasAttribute('aria-invalid')) { control.setAttribute('aria-invalid', 'true'); control.setAttribute('data-ef-lab-invalid', 'true'); }
        });
      });
      if (focus && issues.length) {
        if (focusFrame !== null) cancelAnimationFrame(focusFrame);
        focusFrame = requestAnimationFrame(function () {
          focusFrame = null;
          if (attemptedStep !== visibleStep() || !isShown(issues[0].controls[0])) return;
          var firstRecord = feedback.find(function (record) { return record.group === issues[0].group; });
          if (!firstRecord || !issues[0].controls[0].hasAttribute('data-ef-lab-invalid')) return;
          var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          // Put the instruction and the actual selectable options below the header.
          var target = issues[0].group === issues[0].grid ? firstRecord.message : issues[0].group;
          target.scrollIntoView({ behavior: reduced ? 'instant' : 'smooth', block: 'start' });
          issues[0].controls[0].focus({ preventScroll: true });
        });
      }
    }
    function queueFeedback() {
      clearTimeout(feedbackTimer);
      feedbackTimer = setTimeout(function () { refreshFeedback(false); }, 0);
    }
    function reconcile() {
      if (failed || !cfg.isConnected || !host.isConnected) return;
      var step = visibleStep();
      if (!step || !step.id || !window._efCfgState) return;
      if (!placeOnce()) return;
      // The engine owns navigation and its scroll to this same #efCfg. Only
      // move keyboard focus after a successful human-requested step change.
      if (lastStep && step.id !== lastStep && pendingHuman) focusCurrent();
      lastStep = step.id;
      finishInitial();
    }
    // Observe successful engine navigation, never decide or initiate it.
    window.addEventListener('ef-cfg:state-changed', reconcile);
    window.addEventListener('ef-cfg:state-changed', updateCue);
    window.addEventListener('ef-cfg:state-changed', queueFeedback);
    window.addEventListener('ef-cfg:price-changed', queueFeedback);
    cfg.addEventListener('input', queueFeedback);
    cfg.addEventListener('change', queueFeedback);
    cfg.addEventListener('click', queueFeedback);
    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target.closest('#efCfgNext, #efCfgBack, #efPd2StickyAtc, #efCfg [data-edit-step], #efCfg .ef-cfg-progress__node[data-step]') : null;
      if (!target || !event.isTrusted || !page.contains(cfg)) return;
      pendingHuman = true;
      clearTimeout(intentTimer);
      intentTimer = setTimeout(function () { pendingHuman = false; }, 0);
      if (single || !page.dataset.efLabDoorEntry) return;
      var step = visibleStep();
      if (!step || step.id === 'efCfgStepReview') return;
      if (target.id === 'efPd2StickyAtc' && typeof window.efCfgValidateAndAdvance === 'function') {
        // Keep the existing validation/feedback bridge. It delegates exactly
        // once to the native API and never posts before the native Review.
        event.preventDefault(); event.stopImmediatePropagation();
        if (window.efCfgValidateAndAdvance() === 'highlighted') {
          attemptedStep = step; refreshFeedback(true);
        } else clearFeedback();
      } else if (target.id === 'efCfgNext') {
        // Native Next runs normally. Only decorate a failure it actually reports.
        setTimeout(function () {
          if (step !== visibleStep()) { clearFeedback(); return; }
          var nativeError = step.querySelector('[id^="efCfgErr_"]');
          var invalidInput = Array.prototype.some.call(step.querySelectorAll('input,select'), function (input) {
            return isShown(input) && /192,\s*83,\s*58|#c0533a/i.test(input.style.borderColor);
          });
          if (nativeError || invalidInput) { attemptedStep = step; refreshFeedback(true); }
        }, 0);
      }
    }, true);
    function scrollHash() {
      if (!placed || (location.hash !== '#build' && location.hash !== '#efCfg')) return;
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      cfg.scrollIntoView({ behavior: reduced ? 'instant' : 'smooth', block: 'start' });
    }
    function finishInitial() {
      if (initialResolved) return;
      initialResolved = true;
      scrollHash();
    }
    window.addEventListener('hashchange', scrollHash);
    reconcile();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

/* The full door form now sits beside the product gallery. Mirror the native
   finish renderer there as requested on 2026-09-05. It alone resolves the
   correct product/finish photo; this adapter never selects or prices options.
   Frameless glass screens keep their glass-color owner when no finish render exists. */
(function () {
  'use strict';
  function initFinishGallery() {
    var cfg = document.getElementById('efCfg');
    if (!cfg || !cfg.closest('[data-ef-lab-continuous]') ||
        ['cfg-custom', 'cfg-custom-full', 'cfg-custom-premium', 'cfg-screen'].indexOf(cfg.dataset.cfgType) < 0) return;
    var gallery = document.getElementById('efGallerySwiper');
    var main = gallery && gallery.querySelector('.swiper-slide:first-child img');
    var thumb = document.querySelector('#efGalleryThumbs .swiper-slide:first-child img');
    var preview = document.getElementById('efCfgFinishLivePreview');
    var a = document.getElementById('efCfgFinishLiveImgA');
    var b = document.getElementById('efCfgFinishLiveImgB');
    var tag = document.getElementById('efCfgFinishLiveTag');
    if (!main || !preview || !a || !b || !tag) return;
    gallery.setAttribute('data-ef-lab-finish-gallery', '');
    var originals = [main, thumb].filter(Boolean).map(function (img) {
      return { img: img, attrs: ['src', 'srcset', 'alt'].map(function (name) {
        return { name: name, value: img.getAttribute(name) };
      }), sources: Array.prototype.map.call(img.parentElement.querySelectorAll('source[srcset]'), function (source) {
        return { el: source, value: source.getAttribute('srcset') };
      }) };
    });
    var pending = 0, requested = '', lastSrc = '', lastName = '', applied = false;
    function restore() {
      if (!applied) return;
      originals.forEach(function (record) {
        record.attrs.forEach(function (attr) {
          if (attr.value === null) record.img.removeAttribute(attr.name);
          else record.img.setAttribute(attr.name, attr.value);
        });
        record.sources.forEach(function (source) { source.el.setAttribute('srcset', source.value); });
      });
      gallery.removeAttribute('data-ef-lab-finish');
      applied = false;
    }
    function mirror(src, name) {
      var key = src ? name + '\n' + src : '';
      if (key === requested) return;
      requested = key;
      var ticket = ++pending;
      if (!src) { restore(); return; }
      // Load before swapping; a missing render must never produce a broken
      // hero or leave a previous finish masquerading as the selected one.
      var url = new URL(src, location.href);
      url.searchParams.set('width', '1200');
      var loader = new Image();
      loader.onload = function () {
        if (ticket !== pending || !cfg.isConnected) return;
        originals.forEach(function (record) {
          record.sources.forEach(function (source) { source.el.removeAttribute('srcset'); });
          record.img.removeAttribute('srcset');
          record.img.src = url.href;
          var originalAlt = record.attrs.find(function (attr) { return attr.name === 'alt'; }).value || '';
          record.img.alt = originalAlt + ' — ' + name + ' finish';
        });
        applied = true;
        gallery.setAttribute('data-ef-lab-finish', name);
        // Existing Swiper updates thumbnail/zoom state. Never scroll the page
        // back to the gallery when a customer is configuring on a phone.
        var swiper = gallery.swiper;
        if (swiper && swiper.activeIndex !== 0) swiper.slideTo(0);
      };
      loader.onerror = function () { if (ticket === pending) restore(); };
      loader.src = url.href;
    }
    function sync(records) {
      var name = tag.textContent.trim(), changedSrc = '';
      (records || []).forEach(function (record) {
        if (record.attributeName === 'src' && (record.target === a || record.target === b)) {
          changedSrc = record.target.getAttribute('src') || '';
        }
      });
      // Hidden desktop lazy previews may never fire onload, so .is-shown is
      // not the source of truth. A src mutation is the native renderer output.
      if (changedSrc) lastSrc = changedSrc;
      else if (name !== lastName || !lastSrc) {
        var shown = b.classList.contains('is-shown') ? b : a;
        lastSrc = shown.getAttribute('src') || b.getAttribute('src') || a.getAttribute('src') || '';
      }
      lastName = name;
      mirror(preview.hidden ? '' : lastSrc, name);
    }
    new MutationObserver(sync).observe(preview, {
      subtree: true, childList: true, characterData: true, attributes: true,
      attributeFilter: ['src', 'hidden']
    });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initFinishGallery, { once: true });
  else initFinishGallery();
})();

/* Keep the actual price receipt available before every Next/Review action.
   The existing fixed bar owns its live total; its new disclosure only reads
   the native receipt. No second calculation, option writes or purchase path. */
(function () {
  'use strict';
  function initPriceSummary() {
    var cfg = document.getElementById('efCfg');
    if (!cfg || !cfg.closest('[data-ef-lab-continuous]') ||
        ['cfg-custom', 'cfg-custom-full', 'cfg-custom-premium', 'cfg-screen'].indexOf(cfg.dataset.cfgType) < 0) return;
    var receipt = document.getElementById('efCfgSidebar');
    var lines = document.getElementById('efCfgPriceLines');
    var total = document.getElementById('efCfgTotalPrice');
    var nav = document.getElementById('efCfgNav');
    if (!receipt || !lines || !total || !nav || cfg.hasAttribute('data-ef-lab-price-summary')) return;
    // One permanent position, including Review: the engine addresses the same
    // elements by ID. No clone of the native receipt or commerce controls.
    nav.before(receipt);
    cfg.setAttribute('data-ef-lab-price-summary', '');
    var itemName = cfg.dataset.cfgType === 'cfg-screen' ? 'Screen' : 'Door';
    receipt.querySelector('.ef-cfg-price-total > span:first-child').textContent = itemName + ' total';
    var bar = document.getElementById('efPd2Sticky');
    var price = bar && bar.querySelector('.ef-pd2-sticky__price');
    if (!price) return; // Inline receipt remains available even without a bar.
    bar.setAttribute('data-ef-lab-price-summary', '');
    // Reserve the real bar height when enlarged text wraps its controls.
    // A fixed 72px footer allowance can otherwise hide the last focused link.
    if ('ResizeObserver' in window) new ResizeObserver(function () {
      document.documentElement.style.setProperty('--ef-lab-price-bar-height', Math.ceil(bar.getBoundingClientRect().height) + 'px');
    }).observe(bar);
    var hint = document.createElement('span');
    hint.className = 'ef-lab-price-hint';
    hint.textContent = itemName + ' price details';
    hint.setAttribute('aria-hidden', 'true');
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'ef-lab-price-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', 'efLabPriceDetails');
    price.appendChild(hint);
    price.appendChild(toggle);
    // Sibling of the clipped mobile price wrapper, inside the existing bar's
    // modal/menu stacking context. It adds no permanent viewport obstruction.
    var panel = document.createElement('section');
    panel.id = 'efLabPriceDetails';
    panel.className = 'ef-lab-price-details';
    panel.hidden = true;
    panel.setAttribute('aria-labelledby', 'efLabPriceHeading');
    panel.setAttribute('aria-live', 'off');
    var heading = document.createElement('h2');
    heading.id = 'efLabPriceHeading';
    heading.textContent = itemName + ' price breakdown';
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'ef-lab-price-close';
    close.textContent = '×';
    close.setAttribute('aria-label', 'Close price details');
    var body = document.createElement('div');
    var sum = document.createElement('div');
    sum.className = 'ef-lab-price-details__total';
    var sumLabel = document.createElement('span');
    sumLabel.textContent = itemName + ' total';
    var sumValue = document.createElement('strong');
    sum.appendChild(sumLabel);
    sum.appendChild(sumValue);
    panel.appendChild(heading);
    panel.appendChild(close);
    panel.appendChild(body);
    panel.appendChild(sum);
    var accessories = cfg.querySelector('[data-efx-uac-note]');
    var accessoryModule = accessories && accessories.closest('[data-efx-uac]');
    var extraItems = document.createElement('div');
    extraItems.className = 'ef-lab-price-details__items';
    extraItems.hidden = true;
    panel.appendChild(extraItems);
    var extrasNote = document.createElement('p');
    extrasNote.className = 'ef-lab-price-details__extras';
    extrasNote.hidden = true;
    panel.appendChild(extrasNote);
    bar.appendChild(panel);
    var signature = '', extrasSignature = '';
    function syncPrice() {
      var amount = total.textContent.trim();
      toggle.setAttribute('aria-label', itemName + ' price details. ' + itemName + ' total ' + amount);
      sumValue.textContent = amount;
      // Accessories have a separate native order-total note. Do not relabel
      // the door-only engine total as the complete order or sum it ourselves.
      extrasNote.hidden = !accessories || accessories.hidden || !accessories.textContent.trim();
      extrasNote.textContent = extrasNote.hidden ? '' : accessories.textContent.trim();
      // Read each selected native row, including its current model and finish.
      // Prices and the combined note remain owned by the accessory module.
      var selectedExtras = accessoryModule ? Array.prototype.map.call(accessoryModule.querySelectorAll('[data-efx-acc-tick]:checked'), function (tick) {
        var row = tick.closest('.efx-uac__row, .efx-uac__glcard');
        var priceNode = row && row.querySelector('.efx-uac__price, [data-efx-gl-price]');
        var name = tick.getAttribute('data-name') || '';
        var finish = tick.getAttribute('data-efx-finish-value');
        return [name + (finish ? ' · ' + finish : ''), priceNode ? priceNode.textContent.trim() : ''];
      }) : [];
      var nextExtras = JSON.stringify(selectedExtras);
      if (nextExtras !== extrasSignature) {
        extrasSignature = nextExtras;
        extraItems.hidden = !selectedExtras.length;
        extraItems.textContent = '';
        if (selectedExtras.length) {
          var extraHeading = document.createElement('h3');
          extraHeading.textContent = 'Selected accessories';
          extraItems.appendChild(extraHeading);
          selectedExtras.forEach(function (item) {
            var row = document.createElement('div'), label = document.createElement('span'), value = document.createElement('strong');
            row.className = 'ef-lab-price-details__line';
            label.textContent = item[0]; value.textContent = item[1];
            row.appendChild(label); row.appendChild(value); extraItems.appendChild(row);
          });
        }
      }
      var rows = Array.prototype.map.call(lines.children, function (row) {
        return [row.firstElementChild ? row.firstElementChild.textContent : '', row.lastElementChild ? row.lastElementChild.textContent : ''];
      });
      var next = JSON.stringify(rows);
      if (next === signature) return;
      signature = next;
      body.textContent = '';
      rows.forEach(function (data) {
        var row = document.createElement('div');
        row.className = 'ef-lab-price-details__line';
        var label = document.createElement('span'), value = document.createElement('strong');
        label.textContent = data[0]; value.textContent = data[1];
        row.appendChild(label); row.appendChild(value); body.appendChild(row);
      });
    }
    function setOpen(open, returnFocus) {
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) { syncPrice(); close.focus({ preventScroll:true }); }
      if (returnFocus) toggle.focus({ preventScroll: true });
    }
    toggle.addEventListener('click', function () { setOpen(panel.hidden, false); });
    close.addEventListener('click', function () { setOpen(false, true); });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !panel.hidden) {
        event.preventDefault(); setOpen(false, true);
      }
    });
    document.addEventListener('click', function (event) {
      if (!panel.hidden && !panel.contains(event.target) && event.target !== toggle) setOpen(false, false);
    });
    window.addEventListener('ef-cfg:price-changed', syncPrice);
    // Also covers native render/replay timing without depending on event order.
    new MutationObserver(syncPrice).observe(lines, { childList:true, subtree:true, characterData:true });
    new MutationObserver(syncPrice).observe(total, { childList:true, subtree:true, characterData:true });
    if (accessories) new MutationObserver(syncPrice).observe(accessories, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['hidden'] });
    if (accessoryModule) {
      accessoryModule.addEventListener('change', syncPrice);
      new MutationObserver(syncPrice).observe(accessoryModule, { attributes:true, subtree:true, attributeFilter:['data-name', 'data-price', 'data-efx-finish-value'] });
    }
    var inView = false;
    function phase() {
      var configuring = inView && !nav.classList.contains('is-review-step');
      bar.setAttribute('data-ef-lab-price-phase', configuring ? 'configure' : 'other');
    }
    window.addEventListener('ef-cfg:state-changed', function () { phase(); setOpen(false, false); });
    // The old studio observer no longer owns this permanent form. While its
    // options are visible on a phone, keep price/help and use its real Next;
    // the original Build route returns when the form is out of view.
    if ('IntersectionObserver' in window) new IntersectionObserver(function (entries) {
      inView = entries[0].isIntersecting;
      phase();
      if (!inView) setOpen(false, false);
    }, { rootMargin:'-80px 0px -80px 0px' }).observe(cfg);
    syncPrice();
    phase();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPriceSummary, { once: true });
  else initPriceSummary();
})();

/* Identification only: desktop QR returns through the existing native input.
   Window capture precedes the legacy document picker; mobile keeps its native camera. */
(function () {
 'use strict';
 function init() {
  var box=document.querySelector('.efx-pdp[data-ef-live-pdp-layout] .ef-lab-photo'),card=document.getElementById('efCfgAiCard'),input=document.getElementById('efCfgAiFile'),toggle=document.getElementById('efCfgAiBtn');
  if(!box||!card||!input||box.dataset.relayBound)return;
  box.dataset.relayBound='true';
  var phone=/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)||(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1);
  var cam=card.querySelector('[data-ef-cam="efCfgAiFile"]'),lib=card.querySelector('[data-ef-lib="efCfgAiFile"]');
  // The whole surface is a group of explicit controls, not a file-picker button.
  window.addEventListener('keydown',function(e){if((e.key==='Enter'||e.key===' ')&&e.target.closest&&e.target.closest('.ef-lab-photo .ef-cfg-ai-card__actions button'))e.stopPropagation();},true);
  window.addEventListener('click',function(e){if(!card.contains(e.target)||card.dataset.state!=='idle')return;if(e.target.closest('button,a,input,.ef-cfg-ai-card__thumb'))return;e.stopPropagation();},true);
  var relayDesktop=matchMedia('(min-width:1024px) and (pointer:fine)');
  if(phone||!relayDesktop.matches)return;
  box.setAttribute('data-phone-relay','');
  var panel=document.createElement('div');panel.className='ef-lab-phone';
  panel.innerHTML='<p class="ef-lab-phone__title">Take a photo with your phone</p><p class="ef-lab-phone__intro">Scan with your phone’s camera. Your photo returns to this build.</p><div class="ef-lab-phone__code" aria-label="Scan this QR code with your phone"></div><p class="ef-lab-phone__state" role="status" aria-live="polite"></p><button type="button" class="ef-lab-phone__retry" hidden>Get a new code</button>';
  cam.parentNode.insertBefore(panel,cam);
  var code=panel.querySelector('.ef-lab-phone__code'),state=panel.querySelector('.ef-lab-phone__state'),retry=panel.querySelector('button');
  var relay='https://ef-photo-relay.danielzajacus.workers.dev',run=null,qrPromise=null;
  function stop(){if(!run)return;run.closed=true;clearTimeout(run.timer);run.controllers.forEach(function(c){c.abort();});run=null;}
  function active(r){return run===r&&!r.closed;}
  function request(r,url,options){var c=new AbortController();r.controllers.push(c);var t=setTimeout(function(){c.abort();},10000);return fetch(url,Object.assign({cache:'no-store',credentials:'omit'},options,{signal:c.signal})).finally(function(){clearTimeout(t);r.controllers=r.controllers.filter(function(x){return x!==c;});});}
  function loadQR(){if(window.QRCode)return Promise.resolve();if(qrPromise)return qrPromise;qrPromise=new Promise(function(resolve,reject){var s=document.createElement('script'),t=setTimeout(function(){reject(new Error('qr'));},12000);s.src='https://cdnjs.cloudflare.com/ajax/libs/qrcodejs/1.0.0/qrcode.min.js';s.async=true;s.onload=function(){clearTimeout(t);window.QRCode?resolve():reject(new Error('qr'));};s.onerror=function(){clearTimeout(t);reject(new Error('qr'));};document.head.appendChild(s);}).catch(function(e){qrPromise=null;throw e;});return qrPromise;}
  function failed(r,message){if(!active(r))return;stop();code.replaceChildren();code.textContent='Code unavailable';state.textContent=message;retry.hidden=false;panel.removeAttribute('aria-busy');}
  var heifPromise=null;
  function loadPhotoHeicConverter(){
   if(typeof window.EFConvertHeic==='function')return Promise.resolve(window.EFConvertHeic);
   if(heifPromise)return heifPromise;
   heifPromise=new Promise(function(resolve,reject){
    if(!window.EF_HEIF_URL)return reject(new Error('heic converter unavailable'));
    var script=document.createElement('script'),settled=false;
    var timer=setTimeout(function(){finish(new Error('heic converter timeout'));},20000);
    function finish(error){
     if(settled)return;settled=true;clearTimeout(timer);script.onload=script.onerror=null;
     if(error){script.remove();reject(error);}else resolve(window.EFConvertHeic);
    }
    script.src=window.EF_HEIF_URL;script.async=true;
    script.onload=function(){finish(typeof window.EFConvertHeic==='function'?null:new Error('heic converter missing'));};
    script.onerror=function(){finish(new Error('heic converter network'));};
    document.head.appendChild(script);
   }).catch(function(error){heifPromise=null;throw error;});
   return heifPromise;
  }
  async function inject(r,blob){
   if(!blob.size||blob.size>10*1024*1024||!/^image\//.test(blob.type))throw new Error('image');
   if(!active(r))return;
   if(/^image\/hei[cf](?:-sequence)?$/i.test(blob.type)){
    state.textContent='Converting your iPhone photo…';
    var convert=await loadPhotoHeicConverter();
    if(!active(r))return;
    blob=await convert(new File([blob],'fireplace-phone.heic',{type:blob.type}));
    if(!active(r))return;
    if(!blob||!blob.size||blob.size>10*1024*1024||blob.type!=='image/jpeg')throw new Error('heic converted image');
    state.textContent='Photo received. Identifying your fireplace…';
   }
   await new Promise(function(resolve,reject){var image=new Image(),url=URL.createObjectURL(blob),settled=false,timer=setTimeout(function(){finish(false);},8000);function finish(ok){if(settled)return;settled=true;clearTimeout(timer);image.onload=image.onerror=null;URL.revokeObjectURL(url);ok?resolve():reject(new Error('image'));}image.onload=function(){finish(image.naturalWidth>0&&image.naturalHeight>0);};image.onerror=function(){finish(false);};image.src=url;});
   if(!active(r))return;
   var extension=blob.type==='image/png'?'png':blob.type==='image/webp'?'webp':'jpg';
   var dt=new DataTransfer();dt.items.add(new File([blob],'fireplace-phone.'+extension,{type:blob.type}));input.files=dt.files;if(!input.files.length)throw new Error('file');input.dispatchEvent(new Event('change',{bubbles:true}));
  }
  async function poll(r){
   if(!active(r))return;
   if(Date.now()>=r.expires){failed(r,'This code expired. Get a new code or upload a photo below.');return;}
   try{
    var response=await request(r,relay+'/photos/'+r.token);if(response.status===410){failed(r,'This code expired. Get a new code or upload a photo below.');return;}if(!response.ok)throw new Error('network');
    var list=await response.json();if(!active(r))return;
    var item=Array.isArray(list.ids)&&list.ids.find(function(x){return /^[a-z0-9-]{1,24}$/.test(x.id);});
    if(item){var photo=await request(r,relay+'/photo/'+r.token+'/'+item.id);if(!photo.ok)throw new Error('network');var blob=await photo.blob();if(!active(r))return;state.textContent='Photo received. Identifying your fireplace…';await inject(r,blob);if(active(r))stop();return;}
    r.errors=0;state.textContent='Ready to scan · code valid for 15 minutes';
   }catch(e){if(!active(r))return;r.errors++;state.textContent='Connection interrupted. Reconnecting…';if(r.errors>=4){failed(r,'Could not reconnect. Get a new code or upload a photo below.');return;}}
   if(active(r))r.timer=setTimeout(function(){poll(r);},r.errors?4000:2000);
  }
  async function start(){
   stop();var r={closed:false,timer:null,controllers:[],errors:0};run=r;retry.hidden=true;code.replaceChildren();code.textContent='Preparing code…';state.textContent='Connecting to your phone…';panel.setAttribute('aria-busy','true');
   try{
    var response=await request(r,relay+'/session',{method:'POST'});if(!response.ok)throw new Error('session');var session=await response.json();if(!active(r))return;
    if(!/^[a-z0-9]{6,16}$/.test(session.token))throw new Error('token');var url=new URL(session.phone);if(url.origin!==relay||url.pathname!=='/p/'+session.token)throw new Error('url');
    r.token=session.token;r.expires=Date.now()+Math.min(Number(session.ttl)||900,900)*1000;
    await loadQR();if(!active(r))return;code.replaceChildren();new window.QRCode(code,{text:url.href,width:168,height:168,colorDark:'#121212',colorLight:'#ffffff',correctLevel:window.QRCode.CorrectLevel.M});
    panel.removeAttribute('aria-busy');poll(r);
   }catch(e){failed(r,'Could not create a code. Try again or upload a photo below.');}
  }
  window.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('button');if(relayDesktop.matches&&(b===cam||b===retry)){e.preventDefault();e.stopImmediatePropagation();start();}},true);
  function sync(){if(!relayDesktop.matches){stop();return;}var expanded=!toggle||toggle.getAttribute('aria-expanded')==='true';if(expanded&&card.dataset.state==='idle'&&card.offsetParent!==null){if(!run&&!retry.hidden)return;if(!run)start();}else stop();}
  new MutationObserver(sync).observe(toggle||card,{attributes:true,attributeFilter:['aria-expanded']});
  new MutationObserver(function(){if(card.dataset.state!=='idle')stop();else sync();}).observe(card,{attributes:true,attributeFilter:['data-state']});
  var step=card.closest('.ef-cfg-step');if(step)new MutationObserver(sync).observe(step,{attributes:true,attributeFilter:['class']});
  input.addEventListener('change',function(){if(input.files.length)stop();});
  relayDesktop.addEventListener('change',sync);window.addEventListener('pagehide',stop);window.addEventListener('pageshow',sync);sync();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
}());

/* Shared photo-picker wording; preserve the native multi-photo/camera handlers. */
(function(){function init(){document.querySelectorAll('#efCfgUpload [data-ef-cam]').forEach(function(button){button.setAttribute('data-ef-cam','efCfgFileInput');});document.querySelectorAll('#efCfgUpload .ef-cfg-upload__act--lib').forEach(function(button){button.setAttribute('data-ef-lib','efCfgFileInput');button.childNodes.forEach(function(node){if(node.nodeType===3&&node.textContent.trim())node.textContent='Browse files';});});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();})();
